<template>
  <div>
    <el-row class="hidden-lg-and-up">
      <el-table
        :data="oneTableData"
        @row-click="rowClick"
        :row-class-name="tableRowClassName"
        style="width: 100%">
        <el-table-column
          width="70px">
          <template slot-scope="scope">
            <div class="image clear" style="float: right;">
              <div v-if="scope.row.diagnoseLevel || scope.row.diagnoseLevel === 0"
                   class="diagnoseLevel"
                   :style="{backgroundColor: bgc[scope.row.diagnoseLevel]}">KL{{scope.row.diagnoseLevel}}
              </div>
              <div class="image-wrap"><img :src="scope.row.image | imageFilter"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          column-key="patInfo"
          label="患者信息"
          width="180">
          <template slot-scope="scope">
            <p style="width: 180px; text-align: left">
              <span>{{ scope.row.patName }}</span>
              <span style="margin-left: 5px">{{ !!scope.row.sex && scope.row.sex % 2 === 0 ? '女' : '男' }}</span>
              <span style="margin-left: 5px">{{ scope.row.age }}岁</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="historySn"
          width="180"
          label="病历号">
        </el-table-column>
        <el-table-column
          prop="diagnoseNames"
          label="诊断">
        </el-table-column>
        <el-table-column
          width="120"
          label="标签">
          <template slot-scope="scope">
            <el-tag v-for="(tag, index) in scope.row.tag" :key="index" style="margin: 5px">{{tag}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="随访计划">
          <template slot-scope="scope">
            <span :style="{color: scope.row.hasFollowup ? '#67C23A' : ''}">{{scope.row.hasFollowup ? '有' : '无'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="admissionDate"
          width="150"
          label="日期">
          <template slot-scope="scope">
            {{scope.row.admissionDate | dateFilter}}
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 表格2 -->
    <el-row :gutter="20" class="hidden-lg-and-down">
      <el-col :span="towTableData[1].length === 0 && index === 0 ? 24 : 12" v-for="(tableData, index) in towTableData" :key="index" v-if="tableData.length > 0">
        <el-table
          :data="tableData"
          @row-click="rowClick"
          :row-class-name="tableRowClassName"
          style="width: 100%">
          <el-table-column
            width="70px">
            <template slot-scope="scope">
              <div class="image clear" style="float: right;">
                <div v-if="scope.row.diagnoseLevel"
                     class="diagnoseLevel"
                     :style="{backgroundColor: bgc[scope.row.diagnoseLevel]}">L{{scope.row.diagnoseLevel}}
                </div>
                <div class="image-wrap"><img :src="scope.row.image | imageFilter"></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            column-key="patInfo"
            label="患者信息"
            width="180">
            <template slot-scope="scope">
              <p style="width: 180px; text-align: left">
                <span>{{ scope.row.patName }}</span>
                <span style="margin-left: 5px">{{ !!scope.row.sex && scope.row.sex % 2 === 0 ? '女' : '男' }}</span>
                <span style="margin-left: 5px">{{ scope.row.age }}岁</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column
            prop="historySn"
            width="180"
            label="病历号">
          </el-table-column>
          <el-table-column
            prop="diagnoseNames"
            label="诊断">
          </el-table-column>
          <el-table-column
            label="标签">
            <template slot-scope="scope">
              <el-tag v-for="(tag, index) in scope.row.tag" :key="index" style="margin: 5px">{{tag}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="admissionDate"
            width="150"
            label="日期">
            <template slot-scope="scope">
              {{scope.row.admissionDate | dateFilter}}
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row >
  </div>
</template>

<script>
  import service from '@/request/base'
  import moment from 'moment'
  import _ from 'lodash'

  const notphoto = require('@/assets/record_no_image.png')
  export default {
    name: "record-window-table",
    props: {
      recordList: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data () {
      return {
        oneTableData: [],
        towTableData: [ [], [] ],
        bgc: [
          '#03d679',
          '#03b664',
          '#f5c700',
          '#fe9b00',
          '#e54400',
        ]
      }
    },
    watch: {
      recordList () {
        this.initTableData()
      }
    },
    created() {
      this.initTableData()
    },
    methods: {
      initTableData () {
        const recordList = _.clone(this.recordList)
        this.oneTableData = []
        this.towTableData = [ [], [] ]
        _.forEach(recordList, (val, index) => {
          if (val.tag && val.tag !== '' && val.tag.indexOf('(') !== -1) {
            val.tag = _.join(val.tag.substring(1, val.tag.length - 1).split(')(')).split(',')
          }
          this.oneTableData.push(val)
          if (index % 2 === 0) {
            this.towTableData[0].push(val)
          } else {
            this.towTableData[1].push(val)
          }
        })
      },
      rowClick (row) {
        this.$emit('tableClick', row)
      },
      tableRowClassName(row) {
        if (row.rowIndex % 2 === 0) {
          return 'warning-row';
        }
      }
    },
    filters: {
      imageFilter(value) {
        if (!value) {
          return notphoto
        }
        return service.url(value)
      },
      dateFilter(time) {
        return moment(time).format('YYYY-MM-DD')
      }
    }
  }
</script>

<style scoped>
  @media only screen and (max-width:1799px){
    .hidden-lg-and-down {
      display:none!important
    }
    .hidden-lg-and-up {
      display: block!important
    }
  }
  @media only screen and (min-width:1800px){
    .hidden-lg-and-up {
      display:none!important
    }
    .hidden-lg-and-down {
      display:block!important
    }
  }
  .image {
    width: 40px;
    height: auto;
  }
  .diagnoseLevel {
    width: 22px;
    height: 22px;
    transform: scale(0.8);
    font-size: 12px;
    text-align: center;
    line-height: 22px;
    color: white;
    position: absolute;
    z-index: 999;
    border-radius: 50%;
    top: 7px;
    left: 12px;
  }
  .image-wrap {
    width: 100%;
    height: auto;
    padding-bottom: 100%;
    position: relative;
  }

  .image img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 0;
    display: block;
    margin: auto;
    padding: auto;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
  }
  >>> .warning-row {
    background-color: #e3e4fb17;
  }
</style>
